import { action } from 'mobx';
import { ProductOrderUploadForm } from 'application/product/forms';
import { BaseEditViewStore } from 'core/stores';
import {applicationContext} from 'core/utils';
import {ItemSubcategoryService} from "application/facility-order/services";

@applicationContext
class ProductOrderUploadViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'file',
            Form: ProductOrderUploadForm,
            actions: () => {
                return {
                    create: async () => {
                        var file = this.form.fields.get("file").files[0];
                        await itemSubcategoryService.upload({file: file});
                    }
                }
            },
            FormClass: ProductOrderUploadForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('Products ordering updated successfully.'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'Error occured while trying to update the products ordering.');
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default ProductOrderUploadViewStore;
